const data = [
  {
    title:"Codex using OpenAI",
    img:
      "https://compote.slate.com/images/809a56ff-4b53-4165-99c4-96a8d8543e56.jpeg?crop=5104%2C3403%2Cx0%2Cy0",
    text:
      "A chat box, where we ask questions and receive answers via OpenAI",
      view:'https://codex-open-ai-chi.vercel.app/',
      source:'https://github.com/osr-megha/CodeX-OpenAI'
  },
  {
    title:"Laundry App",
    img:
      "https://www.marthastewart.com/thmb/Flex0vYnG0L0h2MeFaOBKT7k0L4=/750x0/filters:no_upscale():max_bytes(150000):strip_icc():format(webp)/laundry-room-getty-0120-2000-f8be22967cbc4f3c8c18ff5e68dc2777.jpg",
    text:
      "Created using React Native",
      view:'https://github.com/osr-megha/Laundry-App',
      source:'https://github.com/osr-megha/Laundry-App'
  },
    {
      title: "Shopping Cart",
      img:
        "https://images.pexels.com/photos/5614119/pexels-photo-5614119.jpeg?cs=srgb&dl=pexels-anna-shvets-5614119.jpg&fm=jpg",
      text:
        "Shopping cart App with Context API & Google Pay",
      view:'https://guileless-travesseiro-2abd3c.netlify.app/',
      source:'https://github.com/osr-megha/Learn-ContextAPI'
    },
    {
      title: "Login Form",
      img:
        "https://colorlib.com/wp/wp-content/uploads/sites/2/creative-html5-css3-login-form.png",
      text:
        "Login form using React Vite",
        view:'https://react-vite-login-form.vercel.app/',
        source:'https://github.com/osr-megha/React-Vite-LoginForm'
    },
    {
      title: "Crypto Tracker",
      img:
        "https://images.pexels.com/photos/6780789/pexels-photo-6780789.jpeg?cs=srgb&dl=pexels-alesia-kozik-6780789.jpg&fm=jpg",
      text:
        "Crypto tracker App using Line chart",
        view:'https://crypto-tracker-using-line-chart.vercel.app/',
        source:'https://github.com/osr-megha/CryptoTracker-using-Line-Chart'
    },
    {
      title:"Basic React App",
      img:
        "https://images.pexels.com/photos/4126724/pexels-photo-4126724.jpeg?cs=srgb&dl=pexels-ketut-subiyanto-4126724.jpg&fm=jpg",
      text:
        "Learning basic concepts of react js",
        view:'https://learning-react-js.vercel.app/',
        source:'https://github.com/osr-megha/learning-react-js'
    },
  ];

  export default data;